import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Dialog } from '@gem/ui-kit';

import { ICommonPopupsProps } from '../PopupManager/PopupManager.types';

export interface IAlertPopupParams {
  text?: string;
  title?: string;
  html?: string;
  primaryText?: string;
  hasCloseButton?: boolean;
}

export const AlertPopup: FC<ICommonPopupsProps<IAlertPopupParams>> = ({
  params,
  popupInstance,
  onClose,
}) => {
  const { t } = useTranslation();
  const { title, text, html, primaryText, hasCloseButton } = params!;

  const handleClose = (): void => {
    onClose?.();
    popupInstance.close();
  };

  return (
    <Dialog
      isOpened
      title={title}
      text={text}
      html={html}
      hasCloseButton={hasCloseButton}
      primaryText={primaryText || t('common_cancel')}
      primaryOnClick={handleClose}
      onClose={handleClose}
    />
  );
};
